import { TimeslotMapItem, TimeslotsMap } from 'entities/toolbar/timeslots';

export const getTimeslotByHours = (
	timeslotsMap: TimeslotsMap[],
	hours: string,
): TimeslotMapItem[] | false => {
	const slot = timeslotsMap.find(item => parseInt(item[0]) == parseInt(hours));
	if (slot) {
		return slot[1];
	}

	return false;
};

export const getTimeslotIndexByHours = (
	timeslotsMap: TimeslotsMap[],
	hours: string,
) => {
	return timeslotsMap.findIndex(item => parseInt(item[0]) == parseInt(hours));
};

export const getTimeslotByField = (
	timeslotsMap: TimeslotMapItem[],
	field: string,
	value: string | number | boolean,
): TimeslotMapItem | false => {
	const slot = timeslotsMap.find(
		(item: TimeslotMapItem) => item[field] === value,
	);
	if (slot) {
		return slot;
	}

	return false;
};

export const prepareFuncForFindSlotByMinutesRange = (time: Date) => {
	let minute = time.getUTCMinutes();
	if (minute === 59) {
		minute = minute - 1;
	}

	const findFunction = (item: TimeslotMapItem) => {
		return minute >= item.minuteBeginSlot && minute < item.minuteEndSlot
	}
	return findFunction;
};

export const getTimeslotByMinutesRange = (
	timeslotsMap: TimeslotMapItem[],
	time: Date,
) => {
	const func = prepareFuncForFindSlotByMinutesRange(time);

	const slot = timeslotsMap.find(func);
	if (slot) {
		return slot;
	}

	return false;
};

export const findTimeslotIndexByMinutesRange = (
	timeslotsMap: TimeslotMapItem[],
	time: Date = new Date(),
) => {
	const func = prepareFuncForFindSlotByMinutesRange(time);

	const slotIndex = timeslotsMap.findIndex(func);
	if (slotIndex > -1) {
		return slotIndex;
	}

	return false;
};
